import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { SearchEntity } from 'src/app/core/constants/dropdown-contants';
import { FileManagerConst } from 'src/app/core/constants/file-manager.const';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { MyDriveService } from 'src/app/core/services/myDrive/my-drive.service';

@Component({
  selector: 'app-bread-crumb-and-filter',
  templateUrl: './bread-crumb-and-filter.component.html',
  styleUrls: ['./bread-crumb-and-filter.component.scss']
})
export class BreadCrumbAndFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Output() trigger_search: EventEmitter<any> = new EventEmitter();
  @Output() trigger_layout_changed: EventEmitter<any> = new EventEmitter();
  @Output() trigger_create_folder: EventEmitter<any> = new EventEmitter();
  @Output() trigger_file_upload: EventEmitter<any> = new EventEmitter();
  @Input() drive_type: number;
  @Input() folder_id: any;
  
  search_form: FormGroup;
  layout_type = FileManagerConst.LayoutType;
  search_entity = SearchEntity;
  type = FileManagerConst.DriveTypeIds;
  private _unsubscribeAll: Subject<any> = new Subject();
  folder_bradcrumb_details: any[] = [];
  bread_limit: number;

  constructor(
    private _fb: FormBuilder,
    private _driveService: MyDriveService,
    private _router: Router
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['folder_id']?.currentValue) {
      this.folder_id = changes['folder_id']?.currentValue;
    }
  }

  ngOnInit(): void {
    this.getBreadcrumb();
    this.search_form = this._fb.group({
      search: ['']
    })
    this.initiateSearch();
  }

  getBreadcrumb() {
    this.folder_bradcrumb_details = this._driveService.getFolderBreadcrumb();
    if (this.folder_bradcrumb_details?.length) {
      this.bread_limit = (this.folder_bradcrumb_details?.length - 3);
    }
  }

  breadcrumbNavigation(element: any) {
    if (element.id && element.id !== this.folder_id) {
      let find_index = this.folder_bradcrumb_details.findIndex(element => element.id === this.folder_id);
      if (find_index !== -1) {
        this.folder_bradcrumb_details = this.folder_bradcrumb_details.slice(0, (find_index + 1));
      }
      this._driveService.storeBreadcrumb(this.folder_bradcrumb_details);
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
      this._router.navigate([element.url]);
    } else {
      this._router.navigate([element.url]);
    }
  }

  initiateSearch() {
    this.search_form.get('search')
    .valueChanges
    .pipe(
      debounceTime(this.search_entity.debounce_time),
      distinctUntilChanged(),
      takeUntil(this._unsubscribeAll))
    .subscribe((res: string) => {
      this.trigger_search.emit(res);
    })
  }

  layoutChanged(event: MatButtonToggleChange) {
    this.trigger_layout_changed.emit(event.value);
  }

  createFolder(): void {
    this.trigger_create_folder.emit(true);
  }

  createFile() {
    this.trigger_file_upload.emit(true);
  }

  search(): void {
    this.trigger_search.emit(true);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
